import { render } from "./StylesAllMolTypes.vue?vue&type=template&id=54646666&ts=true"
import script from "./StylesAllMolTypes.vue?vue&type=script&lang=ts"
export * from "./StylesAllMolTypes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__